// Strøk-baserte, monokrome «militære» ikoner for verktøylinja (erstatter emoji).
// Alle er 20×20, arver farge via currentColor og linjetykkelse fra CSS. Returnerer
// ferdig SVG-streng (klarert konstant) — tooldock rendrer den via glyphEl.
const A = 'stroke="currentColor" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';
const wrap = (inner: string) =>
  `<svg viewBox="0 0 20 20" width="18" height="18" ${A} aria-hidden="true">${inner}</svg>`;

const PATHS: Record<string, string> = {
  // Kart (foldet kart)
  map: '<path d="M3 5.5 7.5 4l5 1.5L17 4v10.5l-4.5 1.5-5-1.5L3 16z"/><path d="M7.5 4v10.5M12.5 5.5V16"/>',
  // Tegn/mål (blyant)
  pencil: '<path d="M4 16l1-3.5L13.5 4l3 3L8 15.5z"/><path d="M12 5.5l3 3"/>',
  // Enhet (APP-6-ramme)
  unit: '<rect x="3.5" y="5.5" width="13" height="9" rx="0.5"/><path d="M3.5 5.5l6.5 4.5 6.5-4.5"/>',
  // Melding (konvolutt)
  message: '<rect x="3" y="5" width="14" height="10" rx="1"/><path d="M3.5 6l6.5 4.5L16.5 6"/>',
  // Myndighet/ROE (skjold med nøkkelhull — beslutningsrett, ikke beskyttelse)
  authority: '<path d="M10 3l5.5 2.2v4.3c0 3.4-2.2 5.8-5.5 7-3.3-1.2-5.5-3.6-5.5-7V5.2z"/><circle cx="10" cy="9" r="1.3"/><path d="M10 10.3v2.5"/>',
  // Etterretning (øye)
  intel: '<path d="M2.5 10S5.5 5.5 10 5.5 17.5 10 17.5 10 14.5 14.5 10 14.5 2.5 10 2.5 10z"/><circle cx="10" cy="10" r="2"/>',
  // Etterretningspakke (eske med lokk-skille) — nedlastbar samling, ikke en melding.
  package: '<path d="M10 3.2 16.8 6.6v6.8L10 16.8 3.2 13.4V6.6z"/><path d="M3.2 6.6 10 10l6.8-3.4M10 10v6.8"/>',
  // Kalender/dagseddel
  calendar: '<rect x="3.5" y="4.5" width="13" height="12" rx="1"/><path d="M3.5 8h13M7 3v3M13 3v3"/>',
  // Styrke & log (fjell)
  mountain: '<path d="M2.5 15.5l4.5-8 3 4 2-3 5.5 7z"/>',
  // Kompass
  compass: '<circle cx="10" cy="10" r="7"/><path d="M13 7l-2 4-4 2 2-4z"/>',
  // Varsel (bjelle)
  bell: '<path d="M6 13V9a4 4 0 0 1 8 0v4l1.5 2h-11z"/><path d="M8.5 15.5a1.5 1.5 0 0 0 3 0"/>',
  // Sentralbord/samband (kringkasting)
  broadcast: '<circle cx="10" cy="10" r="1.5"/><path d="M6.5 6.5a5 5 0 0 0 0 7M13.5 6.5a5 5 0 0 1 0 7M4.5 4.5a8 8 0 0 0 0 11M15.5 4.5a8 8 0 0 1 0 11"/>',
  // Kontakter (person)
  contacts: '<circle cx="10" cy="7.5" r="2.75"/><path d="M4.5 16a5.5 5.5 0 0 1 11 0"/>',
  // Chat (snakkeboble)
  chat: '<path d="M3.5 5.5h13v8h-7l-3.5 3v-3h-2.5z"/>',
  // PTT/mikrofon
  mic: '<rect x="8" y="3.5" width="4" height="8" rx="2"/><path d="M5.5 10a4.5 4.5 0 0 0 9 0M10 14.5V17"/>',
  // Vedlegg (binders) — Feltvekslerens skrivefelt. Lagt til da bilde/fil/tale
  // ble flyttet inn fra det gamle Chat/TOC-panelet: knappen skulle IKKE bli en
  // emoji (📎) slik den var der, jf. UX-regel 6.
  attach: '<path d="M13.5 9.5 8.8 14.2a2.6 2.6 0 0 1-3.7-3.7l5.6-5.6a3.4 3.4 0 0 1 4.8 4.8l-5.6 5.6a4.2 4.2 0 0 1-6-6l4.3-4.3"/>',
  // RFI/spørsmål
  question: '<circle cx="10" cy="10" r="7"/><path d="M8 8a2 2 0 1 1 2.6 1.9c-.6.2-.9.6-.9 1.3v.3"/><circle cx="10" cy="14" r="0.6" fill="currentColor" stroke="none"/>',
  // Feltkalkulator
  calc: '<rect x="4.5" y="3.5" width="11" height="13" rx="1"/><path d="M6.5 6.5h7M7 10h1.5M9.5 10H11M12.5 10h1M7 12.5h1.5M9.5 12.5H11M12.5 12.5h1"/>',
  // ORBAT (hierarki/tre)
  orbat: '<rect x="8" y="3" width="4" height="3" rx="0.5"/><rect x="3" y="14" width="4" height="3" rx="0.5"/><rect x="13" y="14" width="4" height="3" rx="0.5"/><path d="M10 6v3.5M5 14v-2.5h10V14M10 9.5V11.5"/>',
  // Papirkurv (slett alle)
  trash: '<path d="M5.5 6.5h9l-.8 9.5H6.3zM8 6.5V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5M4 6.5h12"/>',
  // Ildstøtte (eksplosjon/stjerne)
  fire: '<path d="M10 3l1.6 3.4L15 5l-1.4 3.5L17 10l-3.4 1.5L15 15l-3.4-1.6L10 17l-1.6-3.6L5 15l1.4-3.5L3 10l3.4-1.5L5 5l3.4 1.4z"/>',
  // Mållista (sikte)
  crosshair: '<circle cx="10" cy="10" r="6"/><path d="M10 2v4M10 14v4M2 10h4M14 10h4"/>',
  // Logistikk/drivstoff (kanne)
  fuel: '<path d="M4.5 6.5h7v9h-7z"/><path d="M11.5 8.5h2l1.5 1.5v4a1 1 0 0 1-2 0v-2h-1.5M6 4.5h4"/>',
  // Pop-out / åpne i eget vindu (ramme + pil ut)
  popout: '<path d="M11 3h6v6"/><path d="M17 3l-7 7"/><path d="M15 11.5V16a1.5 1.5 0 0 1-1.5 1.5H4.5A1.5 1.5 0 0 1 3 16V6.5A1.5 1.5 0 0 1 4.5 5H9"/>',
  // Kritiske objekter (skjold med diamant) — J-5 nøkkelobjekter
  critical: '<path d="M10 2.5l6 2v5.5c0 3.4-2.4 6.3-6 7.5-3.6-1.2-6-4.1-6-7.5V4.5z"/><path d="M10 6.5l2.4 2.6L10 11.7 7.6 9.1z"/>',
  // Infrastruktur/mast (gittermast med utstråling) — antenne/dekning
  mast: '<path d="M6.5 17L10 4l3.5 13"/><path d="M7.6 12.5h4.8M8.3 9.5h3.4"/><path d="M5 5.5a6 6 0 0 0 0 4M15 5.5a6 6 0 0 1 0 4"/>',
  // Tilgang SPERRET (lukket hengelås). Brukes i RBAC-radene, som er INFORMASJON
  // — låsen er formen som skiller dem fra kartlag-bryterne rett over.
  lock: '<rect x="4.5" y="9" width="11" height="7.5" rx="1"/><path d="M7 9V6.75a3 3 0 0 1 6 0V9"/>',
  // Tilgang TILLATT (åpen hengelås) — samme form, bøylen løftet av.
  'lock-open': '<rect x="4.5" y="9" width="11" height="7.5" rx="1"/><path d="M7 9V6.75a3 3 0 0 1 5.8-1"/>',
  // Meteorologi (sky + sol)
  weather: '<circle cx="7" cy="7.5" r="2.6"/><path d="M7 2.7v1.3M7 11v1.3M2.7 7.5H4M10 7.5h1.3M3.9 4.4l.9.9M9.2 9.7l.9.9M10.1 4.4l-.9.9M4.8 9.7l-.9.9"/><path d="M9 15.5h5a2.5 2.5 0 0 0 .2-5A3.5 3.5 0 0 0 8 9.7 2.5 2.5 0 0 0 9 15.5z"/>',
  // Observasjonsarkivet (arkivskuff med lokk) — historikken, ikke situasjonsbildet.
  arkiv: '<rect x="3" y="4" width="14" height="3.5" rx="0.8"/><path d="M4.5 7.5v8.5h11V7.5"/><path d="M8 10.5h4"/>',
  // Venstre sidepanel av/på (ramme med utfylt venstrekolonne). Viser HVA knappen
  // gjør uten ord — kolonnen er panelet, resten er kartet som får plassen.
  sidepanel: '<rect x="3" y="4" width="14" height="12" rx="1.5"/><path d="M8 4v12"/><path d="M4.6 7.2h1.8M4.6 10h1.8M4.6 12.8h1.8"/>',
  // PTT-kanaler: håndradio med antenne og PTT-knapp på siden. Valgt framfor
  // `broadcast` (som er utstråling, altså EMCON-familien) og `mic` (som er
  // «Meld fra»): dette er APPARATET og kanalene det står på, ikke handlingen å
  // sende. ⚠ Ikke `mast` heller — det er infrastruktur, ikke operatørens radio.
  radio: '<rect x="5.5" y="7" width="9" height="9.5" rx="1.2"/><path d="M11 7 15.5 3"/><path d="M7.5 9.5h4"/><path d="M7.5 12h4"/><rect x="12.6" y="9.3" width="1.4" height="3" rx="0.5"/>',
  // Fliskartlag (ortofoto/DSM — GEO-08): stablede plan, samme idiom som «package».
  layers: '<path d="M10 3.5 17 7l-7 3.5L3 7z"/><path d="M3 10.5 10 14l7-3.5"/><path d="M3 14 10 17.5l7-3.5"/>',
  // Dispatch-kø (DISP-01): rangert kø — tre stolper i AVTAGENDE lengde, høyest
  // (lengst) øverst. Samme idiom som en prioritert liste, ikke en generisk
  // meny (som ville sett ut som ≡ med like lange streker).
  dispatch: '<rect x="3" y="4.5" width="14" height="3" rx="0.6"/><rect x="3" y="8.5" width="10.5" height="3" rx="0.6"/><rect x="3" y="12.5" width="7" height="3" rx="0.6"/>',
};

/** Returner SVG-streng for et navngitt ikon (tom streng om ukjent). */
export function icon(name: keyof typeof PATHS | string): string {
  const p = PATHS[name];
  return p ? wrap(p) : '';
}
